import React from 'react';
const IconMiscList = () => {
  return (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fillRule="evenodd" clipRule="evenodd" d="M4 7V5H20V7H4ZM4 9H20V11H4V9ZM4 17H14V19H4V17ZM4 15H20V13H4V15Z" fill="#666666"/>
</svg>
);
};
export default IconMiscList;